/* Disco Chores — the try-it demo.
   Lifted from the approved mockup. Loads on any page that has a
   [data-dc-demo] element; does nothing on pages that don't.
   Enqueue with: {{ 'dc-demo.js' | asset_url | script_tag }} (defer) */
(function(){
  const $ = s => document.querySelector(s);

  const COLORS = ["#C0A8DE","#BCE6D3","#F2B8D8","#BECFE8","#C57FD0","#B4C2FB"];

  function ballSVG(rows, cols){
    const R = 138, cx = 152, cy = 176;
    const out = [];
    let n = 0;
    for (let i = 0; i < rows; i++){
      const TOP = 0.8;                       // leave the polar caps untiled, like a real ball
      const y0 = -R*TOP + i * (2*R*TOP/rows);
      const y1 = -R*TOP + (i+1) * (2*R*TOP/rows);
      const w0 = Math.sqrt(Math.max(0, R*R - y0*y0));
      const w1 = Math.sqrt(Math.max(0, R*R - y1*y1));
      for (let j = 0; j < cols; j++){
        const l0 = -Math.PI/2 + j * (Math.PI/cols);
        const l1 = -Math.PI/2 + (j+1) * (Math.PI/cols);
        const xt0 = w0*Math.sin(l0), xt1 = w0*Math.sin(l1);
        const xb0 = w1*Math.sin(l0), xb1 = w1*Math.sin(l1);
        n++;
        const pts = [[cx+xt0,cy+y0],[cx+xt1,cy+y0],[cx+xb1,cy+y1],[cx+xb0,cy+y1]]
          .map(q => q[0].toFixed(1)+","+q[1].toFixed(1)).join(" ");
        const mx = cx + (xt0+xt1+xb0+xb1)/4;
        const my = cy + (y0+y1)/2 + 3.2;
        out.push('<polygon class="facet" data-i="'+n+'" points="'+pts+'"><title>Region '+n+'</title></polygon>');
        out.push('<text class="fnum" x="'+mx.toFixed(1)+'" y="'+my.toFixed(1)+'" text-anchor="middle">'+n+'</text>');
      }
    }
    return '<svg viewBox="0 0 304 330" role="img" aria-label="Numbered mirror ball — tick a list item to color its facet">'
      + '<path class="cord" d="M152 4 v22"/>'
      + '<rect x="143" y="25" width="18" height="9" rx="2" fill="none" stroke="currentColor" stroke-width="2"/>'
      + out.join("")
      + '<circle cx="'+cx+'" cy="'+cy+'" r="'+R+'" fill="none" stroke="currentColor" stroke-width="2.5"/>'
      + '</svg>';
  }

  const SAMPLE = ["Make my bed","Call the dentist","Open the mail","Wash the one pan",
    "Water the plants","Take the bins out","Reply to Dana","Book the oil change",
    "Put the laundry away","Cancel the free trial","Change the sheets","Find the passport",
    "Text Mum back","Sweep the hallway","Refill the meds","Clear off the desk",
    "Pay the parking fine","Hang the picture","Sort the junk drawer","Back up the photos",
    "Return the library book","Wipe down the fridge"];

  function buildBoard(ballEl, listEl, countEl, cueEl, rows, cols){
    const TOTAL = rows * cols;
    ballEl.innerHTML = ballSVG(rows, cols);
    const facets = Array.from(ballEl.querySelectorAll(".facet"));

    listEl.innerHTML = Array.from({length: TOTAL}, (_, k) => {
      const i = k + 1;
      const v = SAMPLE[k] ? ' value="'+SAMPLE[k]+'"' : "";
      return '<label class="lrow" data-row="'+i+'">'
        + '<span class="ln">'+i+'.</span>'
        + '<input type="checkbox" aria-label="Finished item '+i+'">'
        + '<input type="text" placeholder="Write something" aria-label="List item '+i+'"'+v+'>'
        + '</label>';
    }).join("");
    const rowsEl = Array.from(listEl.children);

    function facetOf(i){ return facets[i-1]; }

    // One step: crossing an item off colors its square. Ticking and coloring
    // are the same gesture, so there is no in-between state to explain.
    function paint(){
      let done = 0;
      rowsEl.forEach((r, k) => {
        const box = r.querySelector('input[type="checkbox"]');
        const f = facetOf(k + 1);
        const c = COLORS[k % COLORS.length];

        r.classList.toggle("is-done", box.checked);
        r.classList.remove("is-waiting");
        f.classList.remove("is-ready");

        if (box.checked){
          done++;
          f.style.fill = c;
          f.style.stroke = c;
        } else {
          f.style.fill = "";
          f.style.stroke = "";
        }
      });
      countEl.textContent = done;
      cue();
      return done;
    }

    // One invitation, always the same, because there is only ever one move.
    function cue(){
      if (!cueEl) return;
      cueEl.classList.remove("is-two");
      cueEl.innerHTML = '<span class="cuestep">Try it</span>'
        + '<span class="cuetext">Cross something off and watch its square fill in</span>';
    }

    listEl.addEventListener("change", e => {
      if (e.target.type !== "checkbox") return;
      const k = rowsEl.indexOf(e.target.closest(".lrow"));
      const done = paint();
      if (e.target.checked) toast(done % 10 === 0 ? "Ten down." : "Square " + (k + 1) + " colored in.");
    });
    listEl.addEventListener("input", e => { if (e.target.type === "text") paint(); });

    ballEl.addEventListener("click", e => {
      const f = e.target.closest(".facet");
      if (!f) return;
      const k = +f.dataset.i - 1;
      // the board works from either side: clicking a square ticks its item too
      const box = rowsEl[k].querySelector('input[type="checkbox"]');
      box.checked = !box.checked;
      const done = paint();
      if (box.checked) toast(done % 10 === 0 ? "Ten down." : "That's one more piece of the picture.");
    });

    // arrive part-way through, so the picture is already forming on landing
    [1,3,6,8,11].forEach(i => {
      rowsEl[i-1].querySelector('input[type="checkbox"]').checked = true;
    });
    paint();
  }

  /* ---------------- toast ---------------- */
  let toastT;
  function toast(msg){
    const el = $("#dc-toast");
    if (!el) return;
    el.textContent = msg;
    el.classList.add("is-on");
    clearTimeout(toastT);
    toastT = setTimeout(() => el.classList.remove("is-on"), 1700);
  }

  /* ---------------- boot ---------------- */
  function init(){
    document.querySelectorAll("[data-dc-demo]").forEach(function(root){
      if (root.dataset.dcBuilt) return;          // don't rebuild on re-render
      root.dataset.dcBuilt = "1";
      const rows = parseInt(root.dataset.rows || "5", 10);
      const cols = parseInt(root.dataset.cols || "7", 10);
      buildBoard(
        root.querySelector("[data-ball]"),
        root.querySelector("[data-list]"),
        root.querySelector("[data-count]"),
        root.querySelector("[data-cue]"),
        rows, cols
      );
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  document.addEventListener("shopify:section:load", function(e){
    // the editor swaps the node, so clear the guard on anything newly inserted
    (e.target || document).querySelectorAll?.("[data-dc-demo]").forEach(n => delete n.dataset.dcBuilt);
    init();
  });
})();
